import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classnames from "classnames";
import Spinner from "../common/Spinner";
import Avatar from "react-avatar";
//import Spinner from "react-spinkit";
import "react-chat-widget/lib/styles.css";
import firebase from "../../Firebase";
import {
  mqttConnectionInit,
  getPrescriptions,
  openChatBar,
  getApprovedPrescriptions
} from "../../actions/mqttAction";
import { getUsers } from "../../actions/authAction";
import {
  Container,
  Card,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Col,
  Badge,
  Button,
  Alert
} from "reactstrap";
import {
  Button as Button1,
  Checkbox,
  Grid,
  Icon,
  Menu,
  Label,
  Sidebar as Sidebar1,
  Card as SemanticCard,
  Tab,
  Accordion
} from "semantic-ui-react";
import DraftComponent from "./DraftComponent";
import ReviewComponent from "./ReviewComponent";
import ApprovedComponent from "./ApprovedComponent";
import DispensedComponent from "./DispensedComponent";
import {
  Widget,
  addResponseMessage,
  addUserMessage,
  renderCustomComponent,
  toggleWidget,
  dropMessages,
  showCloseButton
} from "react-chat-widget";
import { Dimmer, Image, Segment, Header, Divider } from "semantic-ui-react";
import NotificationComponent from "../../components/Notifications/NotificationComponent";

class ReadListener extends Component {
  componentDidMount() {
    this.props.onOpen();
  }
  componentWillUnmount() {
    this.props.onClose();
  }
  render() {
    return null;
  }
}

Array.prototype.mySwapDelete = function arrayMyShiftDelete(index) {
  var stop = this.length - 1;
  while (index < stop) {
    this[index] = this[++index];
  }

  this.pop();
};

class PharmacistDashboard extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.chatClosedHandler = this.chatClosedHandler.bind(this);
    this.getSiidePush = this.getSiidePush.bind(this);
    this.getChatUsers = this.getChatUsers.bind(this);

    this.chatOpenedHandler = this.chatOpenedHandler.bind(this);
    this.chatClosedHandler = this.chatClosedHandler.bind(this);
    this.handler = this.handler.bind(this);
    this.dispensedHandler = this.dispensedHandler.bind(this);

    this.state = {
      activeIndex: 0,
      ref: "",
      messageList: [],
      can_load_approved: false,
      animation: "overlay",
      direction: "left",
      dimmed: false,
      visible: false,
      activeTab: "1",
      draftedorrejected: [],
      pendingPrescription: [],
      approvedPrescription: [],
      rejected: [],
      widget_state: false,
      app_length: 0,
      disp_length: 0,
      userList: [],
      active: true,
      initialMessage: false,
      chatUsername: "",
      messagesList: [
        {
          author: "them",
          type: "text",
          data: {
            text: "some text"
          }
        },

        {
          author: "me",
          type: "emoji",
          data: {
            code: "someCode"
          }
        },

        {
          author: "me",
          type: "file",
          data: {
            name: "file.mp3",
            url: "https:123.rf/file.mp3"
          }
        }
      ]
    };
  }

  componentDidMount() {
    renderCustomComponent(ReadListener, {
      onOpen: this.chatOpenedHandler,
      onClose: this.chatClosedHandler
    });
    let orgId;
    if (this.props.auth.user.orgId) orgId = this.props.auth.user.orgId;
    else orgId = 1;
    let branchName;
    localStorage.branch
      ? (branchName = localStorage.branch)
      : (branchName = "Chama");
    this.props.getPrescriptions(orgId, branchName);
    addResponseMessage("");
    addUserMessage("");
    this.props.getUsers();

    let refe = firebase.database().ref("Users/" + this.props.auth.user.jti);
    //let client=currentUser
    refe.on("value", snapshot => {
      let counter = 0;
      let mesgSender = "";
      snapshot.forEach(doc => {
        let mesg = JSON.parse(JSON.stringify(doc));
        mesgSender = mesg.client;
      });
      if (mesgSender !== this.state.chatUsername) {
        this.sendNotify(mesgSender);
        this.setState({
          ...this.state,
          newMessageUser: mesgSender
        });
      }
    });
  }

  handler(approvedLength) {
    this.setState({
      ...this.state,
      app_length: approvedLength
    });
  }

  dispensedHandler(dispensedLength) {
    this.setState({
      ...this.state,
      disp_length: dispensedLength
    });
  }

  sendNotify(name) {
    if (this.state.initialMessage) {
      const instance = new NotificationComponent();

      const result = instance.messageNotification(name);
      this.setState({
        ...this.state,
        show_new_label: true
      });
    } else {
      this.setState({
        ...this.state,
        initialMessage: true
      });
    }
  }

  chatOpenedHandler() {
    this.setState({
      ...this.state.widget_state,
      widget_state: true
    });
  }
  chatClosedHandler() {
    this.setState({
      ...this.state.widget_state,
      chatUsername: "",
      widget_state: false
    });
    this.setState({
      ...this.state.chatUsername,
      chatUsername: ""
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.mqtt.prescriptionDetails &&
      nextProps.mqtt.prescriptionDetails.length >= 0
    ) {
      let prescriptionDetails = nextProps.mqtt.prescriptionDetails;
      let pendingreview = [];
      let approved = [];
      let draftedorrejected = [];
      let rejected = [];
      prescriptionDetails.forEach(prescription => {
        if (
          prescription.rxInfo.rxStatus === "Draft" ||
          prescription.rxInfo.rxStatus === "Rejected"
        ) {
          if (prescription.rxInfo.rxStatus === "Rejected") {
            rejected.unshift(prescription);
          }
          draftedorrejected.unshift(prescription);
        }
        if (prescription.rxInfo.rxStatus === "Pending") {
          pendingreview.unshift(prescription);
        }
        if (prescription.rxInfo.rxStatus === "Approved") {
          approved.unshift(prescription);
        }
      });
      //console.log("=================Pending Review Size============="+pendingreview.length)
      this.setState({
        ...this.state,
        draftedorrejected: draftedorrejected,
        pendingPrescription: pendingreview,
        rejected: rejected,
        approvedPrescription: approved,
        active: nextProps.mqtt.initial_load,
        visible: nextProps.mqtt.open_chat,
        userList: nextProps.auth.users,
        can_load_approved: true
      });
      if (Object.keys(nextProps.mqtt.newMessage).length > 0) {
        const draftedPrescriptions = this.state.draftedorrejected;
        const pendingPrescriptions = this.state.pendingPrescription;
        const rejectedPresc = this.state.rejected;

        //console.log("============Inside new Message=============="+nextProps.mqtt.newMessage.rxInfo.rxStatus)
        if (
          nextProps.mqtt.newMessage.rxInfo.rxStatus === "Draft" ||
          nextProps.mqtt.newMessage.rxInfo.rxStatus === "Rejected"
        ) {
          if (nextProps.mqtt.newMessage.rxInfo.rxStatus === "Rejected") {
            rejectedPresc.unshift(nextProps.mqtt.newMessage);
          }
          draftedPrescriptions.unshift(nextProps.mqtt.newMessage);
          //console.log("============Inside new Message==============")

          this.setState({
            ...this.state,
            draftedorrejected: draftedPrescriptions,
            rejected: rejectedPresc
          });
        }
        // else if(nextProps.mqtt.newMessage.rxInfo.rxStatus==="Pending"){
        //   if(nextProps.mqtt.newMessage.isEditing===true){

        //     let pendingIndex = pendingPrescriptions.findIndex(presc => presc.rxInfo.prescriptionNumber === nextProps.mqtt.newMessage.rxInfo.prescriptionNumber)
        //     console.log("=============Pressc number============"+pendingIndex)
        //     pendingPrescriptions.mySwapDelete(pendingIndex);
        //     pendingPrescriptions.unshift(nextProps.mqtt.newMessage);
        //   //console.log("============Inside new Message==============")

        //   this.setState({
        //     ...this.state,
        //     pendingPrescription: pendingPrescriptions
        //   });
        //   }
        //   else{
        //     pendingPrescriptions.unshift(nextProps.mqtt.newMessage);
        //   //console.log("============Inside new Message==============")

        //   this.setState({
        //     ...this.state,
        //     pendingPrescription: pendingPrescriptions
        //   });
        // }

        //   }
      }
    }

    var counter = 0;
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }
  isLoading() {
    return this.props.mqtt.initial_load;
  }

  handleShow = () => this.setState({ active: true });
  handleHide = () => this.setState({ active: false });

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    let newIndex = activeIndex === index ? -1 : index;

    if (newIndex === -1) {
      newIndex = 0;
      if (activeIndex === 0) {
        newIndex = 1;
        if (this.state.can_load_approved) {
          this.props.getApprovedPrescriptions();
        }
      }
    }

    this.setState({ activeIndex: newIndex });
    //console.log("==============Active Index============="+newIndex);
  };

  render() {
    const { roles } = this.props.auth.user;
    let accessRole = roles[0];
    const {
      draftedorrejected,
      pendingPrescription,
      approvedPrescription
    } = this.state;
    const { initial_load } = this.state.active;
    const { loading } = this.props.mqtt;
    let draftedPrescriptions, pendingPrescriptions, approvedPrescriptions, rejectedPrescriptions, dispensedPrescriptions;
    if (loading) {
      draftedPrescriptions = <Spinner />;
    } else {
      if (draftedorrejected && Object.keys(draftedorrejected).length > 0)
        draftedPrescriptions = (
          <DraftComponent drafted={this.state.draftedorrejected} />
        );
      if (this.state.rejected) {
        rejectedPrescriptions = (<DraftComponent drafted={this.state.rejected} />)
      }
    }
    if (loading) {
      pendingPrescriptions = <Spinner />;
    } else {
      if (pendingPrescription && Object.keys(pendingPrescription).length > 0) {
        //console.log("++++=================Pending Length==============="+this.state.pendingPrescription.length)
        pendingPrescriptions = (
          <ReviewComponent
            pendingPrescription={this.state.pendingPrescription}
          />
        );
      }
    }

    if (loading) {
      approvedPrescriptions = <Spinner />;
    } else {
      //console.log("============App length============="+JSON.stringify(approvedPrescription))
      if (Object.keys(approvedPrescription).length === 0) {
        approvedPrescriptions = (
          <ApprovedComponent
            approvedPrescription={this.state.approvedPrescription}
            send_Approve_length={this.handler}
            can_load_approved={this.state.can_load_approved}
          />
        );
      } else {
        approvedPrescriptions = (
          <ApprovedComponent
            approvedPrescription={this.state.approvedPrescription}
            send_Approve_length={this.handler}
            can_load_approved={this.state.can_load_approved}
          />
        );
      }
    }

    if (loading) {
      dispensedPrescriptions = <Spinner />;
    } else {
      dispensedPrescriptions = (
        <DispensedComponent send_Dispense_length={this.dispensedHandler} />
      );
    }
    let toShow;
    //loading = true; let lockScreen = true;
    const { active } = this.state;

    // if (loading) {     toShow = <div className="spinner-div">
    // <Dimmer.Dimmable as={Segment} blurring dimmed={active}>             <Dimmer
    // active={active} onClickOutside={this.handleHide} />         <RingLoader
    //       sizeUnit={"px"}             size={250}             color={'#0e566c'}
    //          loading={this.state.loading}>Bharath</RingLoader>
    // <div><h2>Loading Prescriptions</h2></div>         </Dimmer.Dimmable>
    // </div>
    //
    toShow = (
      // <Dimmer.Dimmable blurring dimmed={active}>
      //     <Dimmer active={active} onClickOutside={this.handleHide} page>
      //         <Header as='h2' icon inverted>
      //         <RingLoader
      //             sizeUnit={"px"}
      //             size={250}
      //             color={'#0e566c'}
      //             loading={this.state.loading}>Bharath</RingLoader>
      //           <div><h2>Loading Prescriptions</h2></div>

      //         </Header>
      //     </Dimmer>
      <Card className="card px-3 py-3 main-container">
        {accessRole === "TECHNICIAN" ? (
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "1"
                })}
                onClick={() => {
                  this.toggle("1");
                }}
              >
                Draft/Rejected
                <Badge color="info" pill className="ml-1">
                  {this.state.draftedorrejected.length}
                </Badge>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "2"
                })}
                onClick={() => {
                  this.toggle("2");
                }}
              >
                Review Pending
                <Badge color="warning" pill className="ml-1">
                  {this.state.pendingPrescription.length}
                </Badge>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "3"
                })}
                onClick={() => {
                  this.toggle("3");
                }}
              >
                Approved
                <Badge color="success" pill className="ml-1">
                  {this.state.app_length}
                </Badge>
              </NavLink>
            </NavItem>
          </Nav>
        ) : (
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "1"
                })}
                onClick={() => {
                  this.toggle("1");
                }}
              >
                Review Pending
                <Badge color="warning" pill className="ml-1">
                  {pendingPrescription.length}
                </Badge>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "2"
                })}
                onClick={() => {
                  this.toggle("2");
                }}
              >
                Approved
                <Badge color="success" pill className="ml-1">
                  {this.state.app_length}
                </Badge>
              </NavLink>
            </NavItem>
          </Nav>
        )}
        {accessRole === "PHARMACIST" ? (
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId="1">
              <Row>
                <Col sm="12">{pendingPrescriptions}</Col>
              </Row>
            </TabPane>
            <TabPane tabId="2">
              <Row>
                <Col sm="12">{approvedPrescriptions}</Col>
              </Row>
            </TabPane>
          </TabContent>
        ) : (
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId="1">
              <Row>
                <Col sm="12">{draftedPrescriptions}</Col>
              </Row>
            </TabPane>
            <TabPane tabId="2">
              <Row>
                <Col sm="12">{pendingPrescriptions}</Col>
              </Row>
            </TabPane>
            <TabPane tabId="3">
              <Row>
                <Col sm="12">{approvedPrescriptions}</Col>
              </Row>
            </TabPane>
          </TabContent>
        )}
      </Card>
    );
    {
      /* //</Dimmer.Dimmable> */
    }

    //}
    let { animation, dimmed, direction, visible } = this.state;
    let showClose = true;

    let draft_pending_panes_list = [
      {
        menuItem: {
          content: (
            <span>
              Draft/Rejected{" "}
              <Badge color="info" pill className="ml-1">
                {this.state.draftedorrejected.length}
              </Badge>
            </span>
          )
        },
        render: () => (
          <Tab.Pane className="tab-pane">{draftedPrescriptions}</Tab.Pane>
        )
      },
      {
        menuItem: {
          content: (
            <span>
              Review Pending{" "}
              <Badge color="warning" pill className="ml-1">
                {this.state.pendingPrescription.length}
              </Badge>
            </span>
          )
        },
        render: () => (
          <Tab.Pane className="tab-pane">{pendingPrescriptions}</Tab.Pane>
        )
      }
    ];

    if (accessRole === "PHARMACIST") {
      draft_pending_panes_list = [
        {
          menuItem: {
            content: (
              <span>
                Review Pending{" "}
                <Badge color="warning" pill className="ml-1">
                  {this.state.pendingPrescription.length}
                </Badge>
              </span>
            )
          },
          render: () => (
            <Tab.Pane className="tab-pane">{pendingPrescriptions}</Tab.Pane>
          )
        },
        {
          menuItem: {
            content: (
              <span>
                Rejected Prescriptions{" "}
                <Badge color="warning" pill className="ml-1">
                  {this.state.rejected.length}
                </Badge>
              </span>
            )
          },
          render: () => (
            <Tab.Pane className="tab-pane">{rejectedPrescriptions}</Tab.Pane>
          )
        }
      ];
    }

    const aprroved_panes_list = [
      {
        menuItem: {
          content: (
            <span>
              Approved{" "}
              <Badge color="success" pill className="ml-1">
                {this.state.app_length}
              </Badge>
            </span>
          )
        },
        pane: (
          <Tab.Pane key="approved-pane" className="tab-pane">{approvedPrescriptions}</Tab.Pane>
        )
      },
      {
        menuItem: {
          content: (
            <span>
              Dispensed{" "}
              <Badge color="success" pill className="ml-1">
                {this.state.disp_length}
              </Badge>
            </span>
          )
        },
        pane: (
          <Tab.Pane key="dispensed-pane" className="tab-pane">{dispensedPrescriptions}</Tab.Pane>
        )
      }
    ];

    let pharma_header = (
      <Row
        style={{
          backgroundColor: "#D3D3D3",
          fontSize: "1rem",
          color: "teal",
          margin: "8px"
        }}
      >
        <Col lg="6" md="6" style={{ margin: "10px" }}>
          <span>
            <Icon name="dropdown"></Icon>
            <strong>Draft/ Rejected/ Pending Actions</strong>{" "}
          </span>
        </Col>

        {/* <Col style={{margin:"10px"}}>
        
      </Col> */}
        <Col style={{ margin: "10px" }}>
          <span>
            {" "}
            <strong>Draft/Rejected :</strong>{" "}
            {this.state.draftedorrejected.length}{" "}
          </span>
        </Col>
        <Col style={{ margin: "10px" }}>
          <span>
            <strong>Pending Review :</strong>{" "}
            {this.state.pendingPrescription.length}{" "}
          </span>
        </Col>
      </Row>
    );
    if (accessRole === "PHARMACIST") {
      pharma_header = (
        <Row
          style={{
            backgroundColor: "#D3D3D3",
            fontSize: "1rem",
            color: "teal",
            margin: "8px"
          }}
        >
          <Col lg="6" md="6" style={{ margin: "10px" }}>
            <span>
              <Icon name="dropdown"></Icon>
              <strong>Pending Actions</strong>{" "}
            </span>
          </Col>

          <Col style={{ margin: "10px" }}>
            <span>
              <strong>Pending Review :</strong>{" "}
              {this.state.pendingPrescription.length}{" "}
            </span>
          </Col>
        </Row>
      );
    }

    const draft_pending_panes = <Tab panes={draft_pending_panes_list} />;
    const approved_panes = <Tab panes={aprroved_panes_list} renderActiveOnly={false} />;
    const { activeIndex } = this.state;
    let accord_draft = (
      <Accordion>
        <Accordion.Title
          active={activeIndex === 0}
          index={0}
          onClick={this.handleClick}
        >
          {pharma_header}
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 0}>
          {draft_pending_panes}
        </Accordion.Content>
        <Accordion.Title
          active={activeIndex === 1}
          index={1}
          onClick={this.handleClick}
        >
          {accessRole === "TECHNICIAN" ? (
            <Alert className="text-center text-bold " color="danger">
              {/* <h3 className="reject-reason"> */}
              <h3>Please Dispense/Restock each Approved script from TeleRx without Fail using Dispense Actions link below ...</h3>
              {/* </h3> */}
            </Alert>) : ''}
          <Row
            style={{
              backgroundColor: "#D3D3D3",
              fontSize: "1rem",
              color: "teal",
              margin: "8px"
            }}
          >
            <Col lg="6" md="6" style={{ margin: "10px" }}>
              <span>
                <Icon name="dropdown"></Icon>
                <strong>Dispense Actions</strong>{" "}
              </span>
            </Col>

            <Col style={{ margin: "10px" }}>
              <span>
                {" "}
                <strong>To Dispense :</strong> {this.state.app_length}{" "}
              </span>
            </Col>

            <Col style={{ margin: "10px" }}>
              <span>
                {" "}
                <strong>Dispensed :</strong> {this.state.disp_length}{" "}
              </span>
            </Col>
          </Row>
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 1}>
          {approved_panes}
        </Accordion.Content>
      </Accordion>
    );

    let draft_pending_cards = (
      <div>
        {/* <SemanticCard style={{width:"100%"}} >
          <SemanticCard.Content>
            {draft_pending_panes}
          </SemanticCard.Content>
        </SemanticCard> */}
        <SemanticCard style={{ width: "100%", marginRight: "8%!important" }}>
          <SemanticCard.Content>{accord_draft}</SemanticCard.Content>
        </SemanticCard>
      </div>
    );

    return (
      <div>
        {/* <Sidebar1.Pushable className="non-scroll-sidebar">
          <div
            className="main-cont"
            style={{ width: "100%", marginLeft: "10%" }}
          >
            {this.getSiidePush()}

            <Sidebar1.Pusher
              dimmed={dimmed && visible}
              className="non-scroll-sidebar "
            >
              {accord_draft}
            </Sidebar1.Pusher>
          </div>
        </Sidebar1.Pushable> */}
        <Sidebar1.Pushable className="non-scroll-sidebar">
          <Container style={{ height: "100vh" }}>
            {this.getSiidePush()}

            <Sidebar1.Pusher
              dimmed={dimmed && visible}
              className="non-scroll-sidebar"
            >
              {accord_draft}
            </Sidebar1.Pusher>
          </Container>
        </Sidebar1.Pushable>

        <Widget
          handleNewUserMessage={this.handleNewUserMessage}
          className="messageWidget"
          title={this.state.chatUsername}
          subtitle=""
          disabled={this.state.chatUsername === ""}
          showCloseButton={showClose}
          badge="1"
          senderPlaceHolder="message ..."
          launcher={handleToggle => <Button hidden></Button>}
        />
      </div>
    );
  }
  // getWidget(){

  //     let widget = <div></div>
  //     if(this.state.chatUsername !== ""){
  //         widget =
  //     }
  //     return widget

  // }

  closeChatBar() {
    toggleWidget();
    // this.props.openChatBar(false);
  }

  handleNewUserMessage = newMessage => {
    let currentUser = this.props.auth.user.jti;
    //let remoteUsr = this.state.user.id;
    let msg = newMessage;
    var moment = require("moment");
    let newDate = moment.utc();
    //newDate.ge
    let reference = this.state.ref;
    let time_stamp = firebase.database.ServerValue.TIMESTAMP;
    this.ref = firebase.database().ref(reference + "/" + newDate);
    let sender = currentUser;
    let prescEnabled = false;
    let prescriptionDetails = {};
    this.ref
      .set({
        msg,
        sender,
        prescEnabled,
        prescriptionDetails,
        current: firebase.database.ServerValue.TIMESTAMP
      })
      .then(docRef => {
        // this.setState({
        //   inputMessage: '',
        //     isPrescription:false,
        //     prescriptionData:{},
        //     prescriptionNumber: ''

        // });
        let refe = firebase
          .database()
          .ref("Users/" + this.state.userRef + "/" + newDate);
        let client = this.props.auth.user.sub;
        refe
          .set({
            client
          })
          .then()
          .catch(e => { });
      })
      .catch(error => {
        console.error("Error adding document: ", error);
      });
    // Now send the message throught the backend API
    //this.handleNewUserMessage("Hello User....?");
    //addResponseMessage(newMessage);
  };

  getSiidePush() {
    let { animation, dimmed, direction, visible } = this.state;
    let chatusers = this.getChatUsers();
    let sidebar = (
      <Sidebar1
        as={Menu}
        animation={animation}
        direction={direction}
        icon="labeled"
        vertical
        visible="true"
        style={{ width: "12%" }}
      >
        <div className="py-4">{chatusers}</div>
      </Sidebar1>
    );
    return sidebar;
  }

  getChatUsers() {
    let xyz = [];
    // can be written in a better way
    if (this.state.userList.length > 0) {
      this.state.userList.map((user, index) => {
        if (user.active) {
          // index % 2 == 0
          //   ? xyz.push(
          //       <div
          //         onClick={() => {
          //           this.getCustomLauncher(
          //             user.firstName + " " + user.lastName,
          //             user.id,
          //             user.roles[0]
          //           );
          //         }}
          //       >
          //         <Avatar
          //           name={user.firstName + " " + user.lastName}
          //           size="30"
          //           round={true}
          //         />
          //         <div
          //           className="nameSpace chat-right"
          //           onClick={() => {
          //             this.getCustomLauncher(
          //               user.firstName + " " + user.lastName,
          //               user.id,
          //               user.roles[0]
          //             );
          //           }}
          //         >
          //           <div
          //             className="chat-right-name"
          //             onClick={() => {
          //               this.getCustomLauncher(
          //                 user.firstName + " " + user.lastName,
          //                 user.id,
          //                 user.roles[0]
          //               );
          //             }}
          //           >
          //             <div
          //               className="chat-user"
          //               onClick={() => {
          //                 this.getCustomLauncher(
          //                   user.firstName + " " + user.lastName,
          //                   user.id,
          //                   user.roles[0]
          //                 );
          //               }}
          //             >
          //               <span
          //                 onClick={() => {
          //                   this.getCustomLauncher(
          //                     user.firstName + " " + user.lastName,
          //                     user.id,
          //                     user.roles[0]
          //                   );
          //                 }}
          //               ></span>
          //               {this.state.newMessageUser !==
          //               user.firstName + " " + user.lastName ? (
          //                 <span
          //                   onClick={() => {
          //                     this.getCustomLauncher(
          //                       user.firstName + " " + user.lastName,
          //                       user.id,
          //                       user.roles[0]
          //                     );
          //                   }}
          //                 >
          //                   {user.firstName + " " + user.lastName}
          //                 </span>
          //               ) : this.state.show_new_label ? (
          //                 <span
          //                   onClick={() => {
          //                     this.getCustomLauncher(
          //                       user.firstName + " " + user.lastName,
          //                       user.id,
          //                       user.roles[0]
          //                     );
          //                   }}
          //                 >
          //                   {user.firstName + " " + user.lastName}
          //                   <Label
          //                     circular
          //                     color="blue"
          //                     key="green"
          //                     size="mini"
          //                   >
          //                     New
          //                   </Label>
          //                 </span>
          //               ) : (
          //                 <span
          //                   onClick={() => {
          //                     this.getCustomLauncher(
          //                       user.firstName + " " + user.lastName,
          //                       user.id,
          //                       user.roles[0]
          //                     );
          //                   }}
          //                 >
          //                   {user.firstName + " " + user.lastName}
          //                 </span>
          //               )}

          //               {/* <Menu.Item as='a'>
          //                   {user.firstName +" " + user.lastName }
          //                   <Label circular empty floating color="teal" key="green" size="mini" />
          //                   </Menu.Item> */}
          //             </div>
          //           </div>
          //         </div>
          //         <Divider />
          //       </div>
          //     )
          //   : 
          xyz.push(
            <div
              onClick={() => {
                this.getCustomLauncher(
                  user.firstName + " " + user.lastName,
                  user.id,
                  user.roles[0]
                );
              }}
            >
              <div
                className="nameSpace chat-right "
                onClick={() => {
                  this.getCustomLauncher(
                    user.firstName + " " + user.lastName,
                    user.id,
                    user.roles[0]
                  );
                }}
              >
                <div
                  className="chat-right-name"
                  onClick={() => {
                    this.getCustomLauncher(
                      user.firstName + " " + user.lastName,
                      user.id,
                      user.roles[0]
                    );
                  }}
                >

                  <div
                    className="chat-user  "
                    onClick={() => {
                      this.getCustomLauncher(
                        user.firstName + " " + user.lastName,
                        user.id,
                        user.roles[0]
                      );
                    }}
                    onClick={() => {
                      this.getCustomLauncher(
                        user.firstName + " " + user.lastName,
                        user.id,
                        user.roles[0]
                      );

                    }}

                  >
                    {/* <span className="chatNames" onClick={() => { this.getCustomLauncher(user.firstName +" " + user.lastName, user.id,user.roles[0]) }}>{user.firstName +" " + user.lastName }
                            </span> */}
                    <Avatar
                      className="mr-4 ml-2"
                      name={user.firstName + " " + user.lastName}
                      size="30"
                      round={true}
                      style={{ float: "left" }}
                    ></Avatar>
                    {this.state.newMessageUser !==
                      user.firstName + " " + user.lastName &&
                      this.state.show_new_label ? (
                      <span
                        onClick={() => {
                          this.getCustomLauncher(
                            user.firstName + " " + user.lastName,
                            user.id,
                            user.roles[0]
                          );
                        }}
                      >
                        {user.firstName + " " + user.lastName}
                      </span>
                    ) : this.state.show_new_label ? (
                      <span
                        onClick={() => {
                          this.getCustomLauncher(
                            user.firstName + " " + user.lastName,
                            user.id,
                            user.roles[0]
                          );
                        }}
                      >
                        {user.firstName + " " + user.lastName}
                        <Label
                          circular
                          color="blue"
                          key="green"
                          size="mini"
                        >
                          New
                        </Label>
                      </span>
                    ) : (
                      <span
                        onClick={() => {
                          this.getCustomLauncher(
                            user.firstName + " " + user.lastName,
                            user.id,
                            user.roles[0]
                          );
                        }}
                      >
                        {user.firstName + " " + user.lastName}
                      </span>
                    )}
                  </div>

                </div>
              </div>
              <Divider />
            </div>
          );
        }
      });
    }

    //firebase.database().ref('Users/'+this.props.auth.user.jti).remove()
    return xyz;
  }
  getCustomLauncher(name, id, role) {
    if (name === this.state.newMessageUser) {
      this.setState({
        ...this.state,
        newMessageUser: ""
      });
    }
    this.setState({
      ...this.state.chatUsername,
      chatUsername: name,
      role: role,
      userRef: id
    });
    //  this.setState({
    //     ...this.state,
    //     user:user,
    //     activeUser: true
    // });
    this.onCollectionUpdate(name, id, role);
    // toggleWidget();
  }

  onCollectionUpdate = (name, id, role) => {
    dropMessages();
    this.setState({
      ...this.state,
      messageList: [],
      ref: "/Messages"
    });
    this.ref = firebase.database().ref("/Messages");

    let user_ref = "";
    let messages = [];
    this.ref.on("value", snapshot => {
      let messages = [];
      let isAVailable = false;
      snapshot.forEach(doc => {
        if (
          doc.key === id + "_" + this.props.auth.user.jti ||
          doc.key === this.props.auth.user.jti + "_" + id
        ) {
          isAVailable = true;
          this.ref = firebase.database().ref("/Messages/" + doc.key);
          user_ref = "/Messages/" + doc.key;
          this.setState({
            ...this.state,
            ref: "/Messages/" + doc.key
          });
          dropMessages();
          doc.forEach(message => {
            let mesg = JSON.parse(JSON.stringify(message));
            if (mesg.sender === id) {
              addResponseMessage("" + mesg.msg);
            } else {
              addUserMessage("" + mesg.msg);
            }
          });
        }
        // else{
        //     this.ref = firebase.database().ref('/Messages/'+doc.key);
        // }
      });

      if (!isAVailable) {
        this.setState({
          ...this.state,
          ref: "/Messages/" + this.props.auth.user.jti + "_" + id,
          messageList: []
        });
        user_ref = "/Messages/" + this.props.auth.user.jti + "_" + id;
      }
      if (isAVailable) {
        this.setState({
          ...this.state,
          messageList: messages
        });
      }
    });
    this.setState({
      ...this.state.chatUsername,
      chatUsername: name,
      role: role,
      userRef: id,
      ref: user_ref
    });
    let widgeg_state = this.state.widget_state;
    if (!this.state.widget_state) {
      console.log("xyz");
      toggleWidget();
    }

    return user_ref;
  };
}

PharmacistDashboard.propTypes = {
  mqttConnectionInit: PropTypes.func.isRequired,
  getPrescriptions: PropTypes.func.isRequired,
  mqtt: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  toggleChat: PropTypes.func.isRequired,
  openChatBar: PropTypes.func.isRequired,
  getUsers: PropTypes.func.isRequired,

  getApprovedPrescriptions: PropTypes.func.isRequired
};

const mapStateToProps = state => ({ mqtt: state.mqtt, auth: state.auth });

export default connect(mapStateToProps, {
  mqttConnectionInit,
  getPrescriptions,
  getUsers,
  openChatBar,
  getApprovedPrescriptions
})(PharmacistDashboard);
